<div class="breadcrumb-header justify-content-between">
  <div class="my-auto">
    <div class="d-flex">
      <h4 class="content-title mb-0 my-auto">Laboratorios</h4>
      <span class="text-muted mt-1 tx-13 ms-2 mb-0">/ Panel de control</span>
    </div>
  </div>
  <div class="d-flex my-xl-auto right-content align-items-center">
    <button class="btn btn-secondary" type="button" (click)="abrirModalAgregar(mdlAgregar)">Agregar</button>
  </div>
</div>

<div class="card">
  <div class="card-body">
    @if (cargando) {
      <p class="text-center mb-0">Cargando...</p>
    }

    @if (!cargando) {
      <div class="table-responsive">
        <table datatable [dtOptions]="dtOptions" class="table table-bordered table-striped table-hover dt-ext">
          <thead>
            <tr>
              <th>#</th>
              <th>Nombre</th>
              <th>Estado</th>
              <th>Fecha de registro</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            @for (lab of laboratorios; track lab; let i = $index) {
              <tr>
                <td>{{ i + 1 }}</td>
                <td class="text-uppercase">{{ lab.NOM_LAB }}</td>
                <td>
                  <button class="btn btn-xs" [ngClass]="lab.EST_LAB != 0 ? 'btn-success' : 'btn-danger'" (click)="alternarEstado(lab)">
                    {{ lab.EST_LAB != 0 ? 'Activado' : 'Desactivado' }}
                  </button>
                </td>
                <td>{{ lab.createdAt | date:'dd/MM/yyyy HH:mm:ss' }}</td>
                <td>
                  <div class="btn-group">
                    <button class="btn btn-warning btn-sm" type="button" (click)="abrirModalEditar(mdlEditar, lab)">
                      <i class="zmdi zmdi-edit text-white"></i>
                    </button>
                    <button class="btn btn-secondary btn-sm" type="button" (click)="verProveedoresDerivados(lab)">
                      <i class="fa fa-eye"></i>
                    </button>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
</div>

<ng-template #mdlAgregar let-modal>
  <div class="modal-header">
    <h6 class="modal-title">Agregar laboratorio</h6>
    <button type="button" class="close" (click)="modal.dismiss()"><span>&times;</span></button>
  </div>
  <div class="modal-body">
    <input type="text" class="form-control" [(ngModel)]="nuevoLaboratorio" placeholder="Ingresar nombre...">
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="modal.dismiss()">Salir</button>
    <button type="button" class="btn btn-secondary" (click)="guardarLaboratorio()" [disabled]="guardando">Guardar</button>
  </div>
</ng-template>

<ng-template #mdlEditar let-modal>
  <div class="modal-header">
    <h6 class="modal-title">Editar laboratorio</h6>
    <button type="button" class="close" (click)="modal.dismiss()"><span>&times;</span></button>
  </div>
  <div class="modal-body">
    <input type="text" class="form-control" [(ngModel)]="editarLaboratorio">
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="modal.dismiss()">Salir</button>
    <button type="button" class="btn btn-secondary" (click)="actualizarLaboratorio()" [disabled]="guardando">Guardar cambios</button>
  </div>
</ng-template>
